<div id="page-banner">
    <div class="page-logo">
        <a href="/"><img src="assets/justMEJTLogo.png" alt="page-logo-jtstudios" /></a>
    </div>

    <div id="hamburger-menu" #burgerMenu><span></span></div>
    <menu id="page-menu-container" #pageContainer role="dialog">
        <nav id="nav-menu">
            <ul class="nav-wrapper">
                <li><a class="nav-link" [routerLink]="'/'">Home</a></li>
                <li><a class="nav-link" href='#page-about-me'>About</a></li>
                <li><a class="nav-link" href='#page-dev-services'>Services</a></li>
                <li><a class="nav-link" [routerLink]="'/resume'">Resume</a></li>
                <li><a class="nav-link" href='#page-contact'>Contact</a></li> 
                <!--<li *ngIf="authenticated"><a class="navLink" [routerLink]="'/profile'">Profile</a></li>-->
            </ul>
        </nav>

        <app-socialmedia></app-socialmedia>

        <!--<div class="page-sign-in"> 
            <a class="page-sign-in-button" [routerLink]="'/signin'"><img src="assets/SignIn.png" alt="signin-button" /></a>
        </div>-->
    </menu>
</div>
